import { useLanguage } from './LanguageContext';
import en from './en';
import de from './de';

const translations = { en, de };

export function useT() {
  const { lang } = useLanguage();
  return translations[lang] || en;
}
